import dayjs from 'dayjs';
import { normalizeExportFilters } from '../../../../utils/exportFilters';

const formatStartOfDay = (value: any) =>
    value && dayjs(value).isValid() ? dayjs(value).startOf('day').toISOString() : undefined;

const formatEndOfDay = (value: any) =>
    value && dayjs(value).isValid() ? dayjs(value).endOf('day').toISOString() : undefined;

/**
 * Filtros aplicados (los que ya pasaron por "Buscar") que alimentan la grilla de
 * presentaciones RGRL/RRL. El rango de fechas vive aparte, en el estado del hook.
 */
export const buildRGRLQueryParams = (
    filters: Record<string, any> = {},
    startDate?: Date | null,
    endDate?: Date | null
): Record<string, any> => ({
    ...filters,
    fechaInicio: formatStartOfDay(startDate),
    fechaFin: formatEndOfDay(endDate)
});

/**
 * Params de /presentaciones/exportar: exactamente los mismos filtros de la grilla,
 * sin paginado, para que el Excel traiga lo que se ve en pantalla (SMP-457).
 * Antes se armaba una lista propia con solo Cliente, Contrato, Organismo y Origen
 * de carga, así que Establecimiento y Estado SRT quedaban afuera del Excel.
 */
export const buildRGRLExportParams = (
    filters: Record<string, any> = {},
    startDate?: Date | null,
    endDate?: Date | null
) => normalizeExportFilters(buildRGRLQueryParams(filters, startDate, endDate));
